import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ObiektListActionsService } from '../core/store/obiekt-list/obiekt-list-actions.service';
// import { NgGridConfig, NgGridItemConfig } from 'angular2-grid';

@Component({
    selector: 'ldn-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardComponent {

    public static route = 'dashboard';

    constructor(private readonly obiektListActionsService: ObiektListActionsService) { }


    // protected grid: NgGridConfig;
    // protected gridItems: DashboardGridItem[];
    //
    // public ngOnInit() {
    //     this.grid = <NgGridConfig>{
    //         max_cols: 6,
    //         max_rows: 6,
    //         row_height: 200,
    //         auto_resize: true,
    //         draggable: true
    //     };
    //
    //     this.gridItems = [];
    //     this.addItem(1, 1, 3, 2, 'Filtry', 'star-o');
    //     this.addItem(4, 1, 3, 2, 'Inne', 'magic');
    //     this.addItem(1, 2, 3, 2, 'Na skróty', 'sign-in');
    //     this.addItem(4, 2, 3, 2, 'Info', 'info-circle');
    // }
    //
    // protected addItem(col: number, row: number, sizex: number, sizey: number, title: string, iconClass: string): void {
    //     const config = <NgGridItemConfig>{
    //         col: col,
    //         row: row,
    //         dragHandle: '.grid-item__header',
    //         sizex: sizex,
    //         sizey: sizey,
    //         draggable: true,
    //         resizable: true
    //     };
    //     this.gridItems.push(new DashboardGridItem(config, title, iconClass));
    // }
    //
    // protected removeItem(item: DashboardGridItem): void {
    //     const index = this.gridItems.indexOf(item);
    //     this.gridItems.splice(index, 1);
    // }

}

export class DashboardGridItem {
    constructor(/*public config: NgGridItemConfig,*/ public title: string, public iconClass: string) { }
}